import React from 'react'

export default function EventUserAvailabilityIndicator({ availability }) {
  function getIndicatorClass() {
    if (availability == 1) {
      return "is-online";
    }
    if (availability == 2) {
      return "is-busy";
    }
    return "is-offline";
  }

  return (
    <div
      className={`event-user-availability-indicator rounded-circle online-indicator ${getIndicatorClass()}`}
    >
      &nbsp;
    </div>
  )
}
